"use client";

import { useQuery } from "@tanstack/react-query";
import { useTranslations } from "next-intl";

import { Card, CardContent, Skeleton } from "@louez/ui";

import { storefrontServicesQueries } from "@/lib/queries/services.queries";

import { ConfiguredServiceForm } from "./configured-service-form";

type ConfiguredServiceLoaderProps = {
  accountHref: string;
  currency: string;
  serviceId: string;
  servicesHref: string;
};

export const ConfiguredServiceLoader = ({
  accountHref,
  currency,
  serviceId,
  servicesHref,
}: ConfiguredServiceLoaderProps) => {
  const t = useTranslations("storefront.services");
  const templateQuery = useQuery(
    storefrontServicesQueries.template(serviceId),
  );

  if (templateQuery.isPending) {
    return <Skeleton className="h-[32rem] w-full rounded-xl" />;
  }

  if (templateQuery.isError) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <h2 className="font-semibold">{t("unavailable")}</h2>
          <p className="text-muted-foreground mt-2 text-sm">
            {t("unavailableDescription")}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <ConfiguredServiceForm
      accountHref={accountHref}
      currency={currency}
      serviceId={serviceId}
      servicesHref={servicesHref}
      template={templateQuery.data}
    />
  );
};
